import { WizardStepBar } from "../../../../common/wizard/WizardStepBar";
import {
  useBidStepLabel,
  useBidStepShortLabel,
  visibleBidStepKeys,
  type BidStep,
  type BidStepVisibility,
} from "./bidWizardSteps";

interface Props {
  currentStep: BidStep;
  navigateToStep: (step: BidStep) => void;
  visibility: BidStepVisibility;
}

export const BidWizardNav = ({ currentStep, navigateToStep, visibility }: Props) => (
  <WizardStepBar
    steps={visibleBidStepKeys(visibility)}
    currentStep={currentStep}
    navigateToStep={navigateToStep}
    stepLabel={useBidStepLabel()}
    stepShortLabel={useBidStepShortLabel()}
  />
);
